export interface FilterParams {
  offset: number;
  limit: number;
}
export enum BrandsEnum {
  VALIO = 'valio',
  FINNY = 'finny',
}

export enum VisibleEnum {
  YES = 'yes',
  NO = 'no',
}

export interface Image {
  id: string;
  categoryId: null;
  productId: null;
  blogInfoId: string;
  teamId: null;
  url: string;
  isMain: boolean;
  sort: number;
}
